<template>
  <div class="setUp">
    <div class="right-menu">
      <!-- <template v-if="device !== 'mobile'">
        <error-log class="errLog-container right-menu-item hover-effect" />
      </template> -->
      <div class="user_info">
        <span class="newMessage" v-if="messageShow" @click="goMessage" v-hasRole="['ROLE_SYS_ADMIN','ROLE_CUS_ADMIN','ROLE_NORMAL']">
          <span class="newMessage1" v-if="newMessageNum > 0">{{ $t('global.newMessage') + newMessageNum + $t('global.newMessage1') }}</span>
          <span v-else>{{ $t('global.nomessage') }}</span>
        </span>
        <span class="company">{{ language === 'zh' ? $store.state.user.enterpriseName : $store.state.user.enterpriseEnName }}
          [{{ $store.state.user.enpid }}]
        </span>
        <span>{{$t('setUp.starLevel')}}：</span>
        <el-rate :colors="['#409EFF', '#409EFF', '#409EFF']" :disabled="true" v-model="rate" style="display: inline-block"></el-rate>
      </div>
      <div class="avatar-container">
        <div @click="showKefu" class="kefu">
          <div class="contacts">
            <img src="@/assets/images/kefu.png" alt="">
          </div>
          <div>
            {{ $t('help.contactUs') }}
          </div>
        </div>
        <el-dropdown class="right-menu-item hover-effect" :hide-on-click="false" trigger="click" @command="handleCommand">
          <div class="avatar-wrapper">
            <img :src="
              $store.state.user.avatar
                ? $store.state.user.avatar
                : `${publicPath}/girl3.png`
            " class="user-avatar" />
            <span class="user-usname">{{ $store.state.user.usname }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">
              {{$t('setUp.personInfo')}}
            </el-dropdown-item>
            <el-dropdown-item command="b">
              {{$t('setUp.changePassword')}}
            </el-dropdown-item>
            <el-dropdown-item command="c">
              {{$t('setUp.bingScipAccount')}}
            </el-dropdown-item>
            <el-dropdown-item>
              <el-dropdown placement='right-start' trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{$t('login.themeSet')}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="blue">{{$t('login.themeBlue')}}</el-dropdown-item>
                  <el-dropdown-item command="green">{{$t('login.themeGreen')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              <span style="display: block">{{ $t("navbar.logOut") }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 弹出表格-->
    <el-dialog :title="$t('setUp.personInfo')" v-if="dialogVisible" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false" :modal-append-to-body="true" append-to-body class="abow_dialog">
      <Profile @closeDialog="dialogVisible = false" />
    </el-dialog>
    <!-- 弹出表格-->
    <el-dialog title="帮助" v-if="dialogHelpVisible" :visible.sync="dialogHelpVisible" width="700px" :close-on-click-modal="false" :modal-append-to-body="true" append-to-body class="abow_dialog">
      <HelpDoc @closeHelpVisible="dialogHelpVisible = false" />
    </el-dialog>
    <!--绑定scip账号-->
    <el-dialog title="绑定scip" v-if="bindScipVisible" :visible.sync="bindScipVisible" width="400px" :close-on-click-modal="false" :modal-append-to-body="true" append-to-body class="abow_dialog">
      <bindScip @closePwdVisible="bindScipVisible = false"></bindScip>
    </el-dialog>
    <!-- 弹出表格-->
    <el-dialog :title="$t('setUp.changePassword')" v-if="dialogPwdVisible" :visible.sync="dialogPwdVisible" width="400px" :close-on-click-modal="false" :modal-append-to-body="true" append-to-body class="abow_dialog">
      <ChangePwd @closePwdVisible="dialogPwdVisible = false" />
    </el-dialog>
    <el-dialog :title="$t('setUp.customerServiceInformation')" v-if="dialogContactusVisible" :visible.sync="dialogContactusVisible" width="400px" :close-on-click-modal="false" :modal-append-to-body="true" append-to-body class="abow_dialog">
      <div class="contact-main">
        <div class="content">
          <div><svg-icon icon-class="tel" />{{$t('help.HSPhone')}}<div>18322561218</div>
          </div>
          <div><svg-icon icon-class="email2" />{{$t('help.ServiceEmail')}}<div>service@camds.org.cn</div>
          </div>
          <div><svg-icon icon-class="time" />{{$t('help.Customerservicetime')}}<div>{{$t('help.mToF')}}8:30-12:00 13:30-17:00({{$t('help.esh')}})</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Profile from "@/components/Profile";
import HelpDoc from "@/components/HelpDoc";
import ChangePwd from "@/components/ChangePwd";
import { hasNewMessage } from '@/api/other/message'
import bindScip from "@/components/bindScip";
export default {
  name: "",
  components: {
    Profile,
    HelpDoc,
    ChangePwd,
    bindScip
  },
  props: {},
  data() {
    return {
      rate: null,
      dialogContactusVisible: false,
      messageShow: true,
      bindScipVisible:false,
      dialogVisible: false,
      dialogHelpVisible: false,
      dialogPwdVisible: false,
      publicPath: process.env.VUE_APP_PROFILE_BASE_URL,
      newMessageNum: 0,
    };
  },
  computed: {
    language() {
      return this.$i18n.locale
    }
  },
  watch: {},
  created() {
    // this.rate = this.$store
    // let obj = this.$store.state.user.menus.find(item => {
    //   if (item.children) {
    //     return item.children.find(ite => {
    //       return ite.name === 'Message'
    //     })
    //   } else {
    //     return item.name === 'Message'
    //   }
    // })
    // if (obj) {
    //   this.messageShow = true;
    // } else {
    //   this.messageShow = false;
    // }
  },
  mounted() {
    this.hasNewMessage()
  },
  methods: {
    styleChange(str) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'style',
        value: str
      })
    },
    showKefu() {
      this.dialogContactusVisible = true;
    },
    logout() {
      this.$confirm(this.language === 'zh' ? "是否确定退出?" : "Are you sure to exit?", this.$t('auxiliaryTools.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      })
        .then(async () => {
          await this.$store.dispatch("user/logout");
          this.$router.push(`/login`);
        })
        .catch(() => {
          return;
        });
    },
    hasNewMessage() {
      hasNewMessage(['']).then(res => {
        this.newMessageNum = res.data;
      })
    },
    goMessage() {
      this.$router.push('/other/message')
    },
    handleCommand(command) {
      if (command === 'a') {
        this.$router.push('/setUserManage/index')
      } else if (command === 'b') {
        this.dialogPwdVisible = true;
      } else if(command === 'c'){
        this.bindScipVisible = true;
      }else if (command === 'blue') {
        this.$store.commit('user/SET_DATATHEME', command);
        document.documentElement.setAttribute('data-theme', command)
      } else if (command === 'green') {
        this.$store.commit('user/SET_DATATHEME', command);
        document.documentElement.setAttribute('data-theme', command)
      }
    }
  },
};
</script>

<style scoped lang="scss">
.setUp {
  height: 100%;
  padding: 5px 50px 5px;
}

.right-menu {
  float: right;
  height: 100%;
  //line-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;

  .user_info {
    font-size: 14px;

    .company {
      margin-right: 20px;
    }
  }

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    //height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-wrapper {
    display: inline-block;
    //align-items: center;
    //margin-right: 20px;

    img {
      height: 26px;
      width: 26px;
      vertical-align: middle;
      margin-right: 20px;
    }

    .user-usname {
      color: #333333;
      font-size: 16px;
      margin-right: 20px;
      letter-spacing: 2px;
    }
  }

  .avatar-container {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    .avatar-wrapper {
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 26px;
        height: 26px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        //position: absolute;
        //right: -20px;
        //top: 25px;
        font-size: 12px;
      }

      @media only screen and (max-width: 1366px) {
        .el-icon-caret-bottom {
          cursor: pointer;
          //position: absolute;
          //right: -20px;
          //top: 18px;
          font-size: 12px;
        }
      }
    }
  }
}

.daping {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.daping-container {
  line-height: 64px;

  img {
    line-height: 64px;
    vertical-align: middle;
  }
}

@media only screen and (max-width: 1366px) {
  //.right-menu {
  //  line-height: 50px;
  //}
  .daping-container {
    line-height: 50px;

    img {
      line-height: 50px;
      vertical-align: middle;
    }
  }
}

.newMessage {
  color: #1890ff;
  font-size: 14px;
  margin-right: 20px;
}

.newMessage1 {
  text-decoration: underline;
  cursor: pointer;
}
.kefu {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid #1a5efd;
  border-radius: 5px;
  padding: 0px 5px;
  .contacts {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #ccc;
    overflow: hidden;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.contact-main {
  width: 350px;
  .title {
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-indent: 10px;
    font-size: 20px;
    font-weight: 700;
    @include background("background-color");
  }
  .content {
    padding: 10px;
  }
  svg {
    @include font-color("color");
  }
}
</style>
